import { Navigate, Route, RouterProvider, Routes, createBrowserRouter } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Downloads from './pages/DownloadsPage';
import Page404 from './pages/404';

const browserRouter = createBrowserRouter([
  { path: '*', Component: Root }
]);

export default function CustomRouter() {
  return <RouterProvider router={browserRouter} />
}

function Root() {
  return (
    <Routes>
      <Route path='/' element={<MainLayout />}>
        <Route path='404' element={<Page404 />} />
        <Route path='' element={<Navigate to='/downloads' />} />
        <Route path='*' element={<Navigate to='/404' />} />
      </Route>
      <Route path='/downloads' element={<MainLayout />}>
        <Route path='' element={<Downloads />} />

        <Route path=':productCategory' element={<Downloads />} />
        <Route path=':productCategory/:productLine' element={<Downloads />} />
        <Route path=':productCategory/:productLine/:product' element={<Downloads />} />
        <Route path=':productCategory/:productLine/:product/:version' element={<Downloads />} />
      </Route>
      <Route path='/knowledgebase' element={<MainLayout />}>
      </Route>
      <Route path='/tickets' element={<MainLayout />}>
      </Route>
      <Route path='/contact-us' element={<MainLayout />}>
      </Route>
    </Routes>
  );
}
